export const formatNumber = (
    number: string | number | null | undefined,
): string => {
    if (number === null || number === undefined) {
        return '';
    }

    const num = typeof number === 'string' ? Number.parseFloat(number) : number;

    if (Number.isNaN(num)) {
        return '';
    }

    return num.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
};
